// Reference: https://github.com/chakra-ui/chakra-ui/blob/main/packages/hooks/src/use-disclosure.ts
import { useState, useCallback } from 'react';

/**
 * Assumption: if we send `isOpen` props into useDisclosure, this hook assume we always send `onClose` and `onOpen`
 */
const useDisclosure = ({
  isOpen: isOpenProps,
  onOpen: onOpenProps,
  onClose: onCloseProps,
} = {}) => {
  const [isOpenState, setIsOpen] = useState(isOpenProps || false);

  const isControlled = isOpenProps !== undefined;
  const isOpen = isControlled && typeof isOpenProps !== 'undefined' ? isOpenProps : isOpenState;

  const onClose = useCallback(() => {
    if (!isControlled) {
      setIsOpen(false);
    }
    onCloseProps?.();
  }, [isControlled, onCloseProps]);

  const onOpen = useCallback(() => {
    if (!isControlled) {
      setIsOpen(true);
    }
    onOpenProps?.();
  }, [isControlled, onOpenProps]);

  const onToggle = useCallback(() => {
    const action = isOpen ? onClose : onOpen;
    action();
  }, [isOpen, onClose, onOpen]);

  return [!!isOpen, onOpen, onClose, onToggle];
};

export default useDisclosure;
